import React from 'react';
import './Extracurricular.css';

const Extracurricular = () => {
  const activities = [
    {
      icon: 'fa-users',
      title: 'Member, CSE Department',
      organization: 'Department Academic Research Committee (DARC)',
      location: 'IIITDM Kancheepuram',
      period: 'Jul 2023 - Present',
      description: [
        'Collaborated on course and initiative discussions proposed by faculty',
        'Gained professional development and networking experience'
      ]
    },
    {
      icon: 'fa-code',
      title: 'Joint Core, Competitive Programming Wing',
      organization: 'CS CLUB',
      location: 'IIITDM Kancheepuram',
      period: 'Aug 2023 - May 2024',
      description: [
        'Hosted coding contests on platforms like CodeChef and HackerRank',
        'Conducted focused training sessions for members'
      ]
    },
    {
      icon: 'fa-briefcase',
      title: 'Placement Volunteer',
      organization: 'Placement Cell',
      location: 'IIITDM Kancheepuram',
      period: 'Aug 2023 - May 2024',
      description: [
        'Collaborated with placement team to connect with recruiters and strengthen industry ties',
        'Contributed to enhancing student employability through teamwork and communication'
      ]
    }
  ];

  return (
    <section id="extracurricular" className="extracurricular">
      <div className="container">
        <h1 className="section-title">Leadership & Extracurricular Activities</h1>
        <div className="extracurricular-grid">
          {activities.map((activity, index) => (
            <div key={index} className="extracurricular-card">
              <div className="activity-icon">
                <i className={`fas ${activity.icon}`}></i>
              </div>
              <h2>{activity.title}</h2>
              <h3>{activity.organization}</h3>
              <p className="location">{activity.location}</p>
              <p className="period">{activity.period}</p>
              <ul className="description">
                {activity.description.map((desc, idx) => (
                  <li key={idx}>{desc}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Extracurricular;
